// tslint:disable: object-literal-sort-keys
// tslint:disable: max-line-length

import { CanonicalBookMap } from '../canonicalBookMap';

export default {
  /* American Government 1e */ '5bcc0e59-7345-421d-8507-a1e4608685e8': [
    /* American Government 3e */ ['30e47181-f52c-4a91-9c11-33380c428268', {
      /* Preface to the same module in 2e */
      '63509fa8-58ee-479c-b8d8-686908ddd971': '3ddde3e1-0765-4692-a525-58f481af278b',
      /* 1.0 Introduction to the same module in 2e */
      '4a3754eb-83a0-4a71-aa2c-aa8dfcd00086': '47f8f28a-cfb1-4323-8f23-c7bd71856e99',
      /* 1.1 What is Government? to the same module in 2e */
      '49abac0f-b70e-4be9-9cf2-495966413644': '1105deb5-ddeb-4777-80cf-f844a0d1492b',
      /* 1.2 Who Governs? Elitism, Pluralism, and Tradeoffs to the same module in 2e */
      'a8ae7f1c-0874-499c-b92c-a3690dc92d1c': '1df654ee-6899-49a8-a1a2-8a6f85610fa3',
      /* 1.3 Engagement in a Democracy to the same module in 2e */
      'a7a5f339-252d-4b50-83ed-a2495bc02779': '3cde8682-1626-42e6-902d-d6f01e4cc538',
      /* 2.0 Introduction to the same module in 2e */
      '67151eaa-f25c-4e63-ba20-9ab902031081': '0acb62c3-5ee2-4202-a325-96983c7015d9',
      /* 2.1 The Pre-Revolutionary Period and the Roots of the American Political Tradition to the same module in 2e */
      'd7f8e6e8-48fb-48d2-9998-e946750e7996': '26e5cf13-84b1-40ad-8538-8fbd73ab94cf',
      /* 2.2 The Articles of Confederation to the same module in 2e */
      '18083da1-5f89-4378-ba19-aa95e6996459': 'b1c8c9e2-5571-4d8e-85db-0a3d6d9cb17b',
      /* 2.3 The Development of the Constitution to the same module in 2e */
      '3dfca04b-06c7-4279-9602-6360152f1f37': 'b4b48c79-2ad8-45fe-9993-e37900e03d8a',
      /* 2.4 The Ratification of the Constitution to the same module in 2e */
      '3416922d-f5b2-431d-8793-89ed4b191fbb': '5dfb7c7b-c9c2-4911-8769-873adc2d054d',
      /* 2.5 Constitutional Change to the same module in 2e */
      '8d723639-0e23-4a8d-9446-735b192d64df': '40f8c706-891b-4236-891d-13159e643868',
      /* 3.0 Introduction to the same module in 2e */
      '52162b03-5104-4d98-993d-52e4c5fca3bf': 'f7de2032-db57-44ed-9b6c-2453aa420cc9',
      /* 3.1 The Division of Powers to the same module in 2e */
      '6ccea6dd-6e15-437e-a026-4e4ef01c75ad': '24e2e5a3-0f2d-442b-ad45-87d7ebd4ad78',
      /* 3.2 The Evolution of American Federalism to the same module in 2e */
      'd124704d-7e8a-4c87-bcef-6ce608f3b435': '8343b65e-02ae-493f-b015-83b060b81649',
      /* 3.3 Intergovernmental Relationships to the same module in 2e */
      '6681afcf-ddc2-4de4-a4d3-7ee7f94d44ae': '0fc32f7c-a8e3-4739-9729-4297630e2646',
      /* 3.4 Competitive Federalism Today to the same module in 2e */
      '76697fff-e01d-4f3e-97c5-eba408cd8009': 'b34fa025-904a-41ab-af57-a54866886dd4',
      /* 3.5 Advantages and Disadvantages of Federalism to the same module in 2e */
      '46814db9-5d28-4e66-a8a4-7c79c484fc45': '015fceb6-72f3-413b-95d9-fddfbb2cbc41',
      /* 4.0 Introduction to the same module in 2e */
      '0d6e143b-69fd-422b-9954-6dbbf6b36008': '2db6b141-4e2e-43f0-b782-b241acf60b55',
      /* 4.1 What Are Civil Liberties? to the same module in 2e */
      '2aafcd29-e648-4b86-b8b7-84d0ce46f906': 'eb3e05c2-0768-4325-9ef2-80f400303115',
      /* 4.2 Securing Basic Freedoms to the same module in 2e */
      '41270e16-46ff-4790-be8a-9c43bfc05254': '57462d7e-2d4a-4866-85b8-00b9d09544d1',
      /* 4.3 The Rights of Suspects to the same module in 2e */
      'ed22cb13-2f14-460f-a603-fb1631f4c6f6': '7760a2b3-c3b9-416c-9520-b8cc4fa954fa',
      /* 4.4 Interpreting the Bill of Rights to the same module in 2e */
      'fdf44e79-776e-477e-963c-a6c0a98c434a': 'cb752abe-3cf9-4da4-8fc5-60b9e3752e5a',
      /* 5.0 Introduction to the same module in 2e */
      '9fab3e71-ddb5-4dd9-bfd4-c9bc9b98141e': '9d5dd1d4-a37c-45be-a6c5-1af41cabed33',
      /* 5.1 What Are Civil Rights and How Do We Identify Them? to the same module in 2e */
      '75bad956-ba62-4639-92cf-d25fc3bdd9f1': '2d27051a-78f8-4af2-acc1-d6ca2217ef70',
      /* 5.2 The African American Struggle for Equality to the same module in 2e */
      '7d34ddc8-ed22-4aa0-9e74-b5f5d2a2974b': '74a23661-4daf-4a10-bc9d-c3ed4f376559',
      /* 5.3 The Fight for Women’s Rights to the same module in 2e */
      'f321ca0c-3392-45e1-a76d-092cd31fb2a5': '9e78d921-0fcf-442a-9559-fb776b07f83a',
      /* 5.4 Civil Rights for Indigenous Groups: Native Americans, Alaskans, and Hawaiians to the same module in 2e */
      'bf879400-500f-4feb-8744-452675525e2c': 'abd1148e-11a9-497a-a8b9-5fb54fa0fa65',
      /* 5.5 Equal Protection for Other Groups to the same module in 2e */
      'e9332f2b-7721-463a-9b96-e67c74fc1f5b': 'adbb9b19-c66e-4349-84ec-ac884a95350f',
      /* 6.0 Introduction to the same module in 2e */
      '7cc1a318-0d76-40e5-ae5a-0a7f52ddf7e2': 'df668cb5-1468-413b-bb81-48892079c551',
      /* 6.1 The Nature of Public Opinion to the same module in 2e */
      '81fbf31f-7c89-4a96-9789-48e2b564ad22': '27c601c8-bbe9-47e2-9d5d-530471dc0d6d',
      /* 6.2 How Is Public Opinion Measured? to the same module in 2e */
      '5fd3ce15-f0ea-47ea-ae8e-84d8f9e2930a': '6a864811-c55a-4a9b-86f1-e54f7f267200',
      /* 6.3 What Does the Public Think? to the same module in 2e */
      '2e6466e7-f162-4327-82fa-58935ff6991a': '6a4ab4fc-1153-4177-9f06-5674d9e2d35c',
      /* 6.4 The Effects of Public Opinion to the same module in 2e */
      'ed844365-afb4-47d1-9428-c4f473e7366e': '035914b9-6d85-44e2-aa6a-b5ea7a4a0de3',
      /* 7.0 Introduction to the same module in 2e */
      '81163025-bf42-4059-8160-cacca24446dc': 'cc0700a4-b5dd-4f20-be5d-ab2197d6aba9',
      /* 7.1 Voter Registration to the same module in 2e */
      '3edaca44-5ab0-4a42-a6b8-4247f6faa221': '6ef5c455-9913-48dd-b5dc-baa1c504d705',
      /* 7.2 Voter Turnout to the same module in 2e */
      '6e795d7a-5b58-4249-a926-918b62e36454': '82c33a61-85a8-4d52-9da1-22557766fe8a',
      /* 7.3 Elections to the same module in 2e */
      '4673fb51-9c11-4ffc-b282-a9aeab42d5a0': 'af5199d5-f904-4823-93a1-e6d7d07b3e31',
      /* 7.4 Campaigns and Voting to the same module in 2e */
      'bda29a31-1f25-4371-8376-785c6a0ddf9a': 'f5119285-0710-42ac-b138-8c0d29f475fd',
      /* 7.5 Direct Democracy to the same module in 2e */
      '7f85b54d-4062-4945-bfa9-2ebca3dd2a61': '0ecf3286-577c-4e30-b3c8-fb404d662bfa',
      /* 8.0 Introduction to the same module in 2e */
      '9a5cabad-893a-48f7-bce0-339ea4a6e9c0': '4ae046d7-323a-4461-b376-80fb519a2b9f',
      /* 8.1 What Is the Media? to the same module in 2e */
      'cb580850-c3f8-4763-914a-442151866495': 'd99257c0-99a0-4fbd-a37d-24dc4f8b4bf6',
      /* 8.2 The Evolution of the Media to the same module in 2e */
      '8c5fc05a-8a77-4fe5-aabc-fa17072249d5': '7ddcab89-17f6-44a1-b776-fbcd5496cfa0',
      /* 8.3 Regulating the Media to the same module in 2e */
      'e8568b4f-0c23-44d8-8c56-e0672bc31c8a': 'ddaabc97-5173-416c-a395-93de3b97cc29',
      /* 8.4 The Impact of the Media to the same module in 2e */
      '55697c4a-b143-4bc6-8831-f75a3c1c06cb': '79abc4c0-9d0d-46fd-8f4b-d9e5342e4521',
      /* 9.0 Introduction to the same module in 2e */
      'e2607669-d582-4ec0-9c58-5e5dcfaaf6a2': 'a249315d-6f4b-42c2-9b47-b95452c61a91',
      /* 9.1 What Are Parties and How Did They Form? to the same module in 2e */
      '9824235e-9e98-4cf1-af98-f569754dc520': '1256514d-6e71-40f1-9990-991749dfda9e',
      /* 9.2 The Two-Party System to the same module in 2e */
      'a5c1983c-ba62-47b1-877f-a24d8201d5a8': 'bd6b97dc-a859-434d-be99-e8739b6bb0dd',
      /* 9.3 The Shape of Modern Political Parties to the same module in 2e */
      '9c71f4d0-d6df-481b-9996-ce751ca49f96': '64a9b2ad-babb-4834-abd9-a69b6bb7a6fe',
      /* 9.4 Divided Government and Partisan Polarization to the same module in 2e */
      'b622df1d-07e9-4a16-ba51-97993fa74899': '767541a3-4cf0-4b69-9afe-70eb5e5f9b1f',
      /* 10.0 Introduction to the same module in 2e */
      '023c8dc9-73ff-415e-a425-740122f650e4': '10b9f291-6c21-4b2a-bfa5-d9f956a7b115',
      /* 10.1 Interest Groups Defined to the same module in 2e */
      'b7e4fad8-6af8-4a63-a83c-0985ba6ff07b': '08ab7418-4b34-4a12-afa6-fd914a715079',
      /* 10.2 Collective Action and Interest Group Formation to the same module in 2e */
      'f71475e4-c8d2-4a4e-8fca-cf854bb8f31b': '8320d218-36c4-4389-8f51-f0e59e2eeeee',
      /* 10.3 Interest Groups as Political Participation to the same module in 2e */
      '621c1d37-0bc1-4190-a1b2-a9331f890b1a': 'f9500c23-31fc-40e8-94c5-334884b54d46',
      /* 10.4 Pathways of Interest Group Influence to the same module in 2e */
      '9a5be432-ccff-4c68-bd2f-54ee60f1afb2': '37864b89-ebe7-470b-82d3-35944aa44819',
      /* 10.5 Free Speech and the Regulation of Interest Groups to the same module in 2e */
      'fa69014a-50c5-4c8d-9b72-d87ee964e83f': '7b71fbfd-9476-4f54-928f-8156f7a6a893',
      /* 11.0 Introduction to the same module in 2e */
      'b4d25da7-c2d6-4f0d-a4b5-b7ce3094435a': 'fe018d16-2067-40ba-835d-89e0b9f7e039',
      /* 11.1 The Institutional Design of Congress to the same module in 2e */
      '8a78fac5-9323-4dca-8c28-cd103cce83c8': '6199efb8-f2eb-490f-9ac2-27c644fa9387',
      /* 11.2 Congressional Elections to the same module in 2e */
      '555946f7-b655-4976-b2a7-4c0e6c246330': '6e9ad9d6-4fd5-4950-b9a0-fe847f9a75fe',
      /* 11.3 Congressional Representation to the same module in 2e */
      '1db17831-5aba-4aba-aa4a-0146e2e02998': 'c1bd3f27-d95e-4322-8753-a023ea892917',
      /* 11.4 House and Senate Organizations to the same module in 2e */
      'efc2d9ee-e3a6-4ab6-a381-b86ce9075d2d': '710f9908-e826-4b95-9195-2fe844cf3191',
      /* 11.5 The Legislative Process to the same module in 2e */
      'c6ee95dd-d10b-430c-8a83-20d5a28334a9': '343f9e7b-2486-4aba-b746-8984c04ae82a',
      /* 12.0 Introduction to the same module in 2e */
      '65305fe4-edf8-486c-ad1e-4b693fe3c0d3': '310044aa-f728-4875-99f8-54fd5f771aba',
      /* 12.1 The Design and Evolution of the Presidency to the same module in 2e */
      '5abe0bea-2667-4c18-bcda-634d14955c44': '932d9a9e-e892-48fb-9541-5116d6a805e1',
      /* 12.2 The Presidential Election Process to the same module in 2e */
      'a7afa056-d34b-4390-bf2e-4057701100ca': 'f27a2d49-5377-4915-a1e4-fbc470346010',
      /* 12.3 Organizing to Govern to the same module in 2e */
      '33651201-eefb-4b44-83d7-692c92be5d85': '481612e6-f7e2-4fee-9ec2-90a811bbab1c',
      /* 12.4 The Public Presidency to the same module in 2e */
      '27b0fa06-f702-47f9-bc56-776ff4cd74ec': 'e3571a7b-3d87-4ac5-9642-981141b86dbe',
      /* 12.5 Presidential Governance: Direct Presidential Action to the same module in 2e */
      '8469ef00-4d28-4cd8-99ab-f77b9bbc0acc': 'de1695dc-a8e6-474a-a703-9d8b00c1ee1d',
      /* 13.0 Introduction to the same module in 2e */
      '08dfa8e7-2bd3-44ed-a527-1dfd46b67215': 'fa7f59b0-7449-4259-ac58-c03a48e91a63',
      /* 13.1 Guardians of the Constitution and Individual Rights to the same module in 2e */
      '0c441e8b-99de-4706-915c-615af32b2aa0': 'fa0a555c-ebd6-4c95-a6e9-b13f56b991dc',
      /* 13.2 The Dual Court System to the same module in 2e */
      'f6315546-7b9f-4f19-9114-e9e3c4a7f8d9': 'a44deb15-adb0-4b53-8639-655481d0a424',
      /* 13.3 The Federal Court System to the same module in 2e */
      'e99782f8-f975-41a3-a08c-84c907aad93d': '3f70a13f-b0ee-4352-85ca-133d1163e1f0',
      /* 13.4 The Supreme Court to the same module in 2e */
      '9f08b241-bb66-48ed-bfde-aa09adf11145': '94177f18-ac67-4cfc-b2e7-77c694457ba4',
      /* 13.5 Judicial Decision-Making and Implementation by the Supreme Court to the same module in 2e */
      'f11ccf83-1b1e-4c33-9f37-4ad3e09509e1': '4a2a2bda-0f5d-454c-8a23-04df0002e0d1',
      /* 14.0 Introduction to the same module in 2e */
      '2387f759-b473-4eca-addf-ce4647da62a9': '12759463-1dc1-49e7-96a6-280154ef0a0c',
      /* 14.1 State Power and Delegation to the same module in 2e */
      '2b8d9fc0-b165-44b0-88de-ad0327cf4c00': '246672e7-c242-430d-a7bf-92d222774ada',
      /* 14.2 State Political Culture to the same module in 2e */
      'd76b7e9e-cf6a-498f-b9e2-32a57b967577': '8e532a78-4479-4484-906b-f7c0997cb627',
      /* 14.3 Governors and State Legislatures to the same module in 2e */
      '1d159c7f-e08c-417d-80aa-8a157a957c76': '7a179ea7-cc0d-4e63-b289-dbc5734ed409',
      /* 14.4 State Legislative Term Limits to the same module in 2e */
      '6df3591b-d82c-4603-9586-cb7f4fb0af1a': '2f232356-cbee-4fbb-84a7-f09087818965',
      /* 14.5 County and City Government to the same module in 2e */
      '851a64e1-b529-4707-951f-b033813b146c': 'ad7cceb0-fb00-4395-b54b-9cab17583a8a',
      /* 15.0 Introduction to the same module in 2e */
      '3486b86f-ed32-425d-92c9-deb2962e555d': 'd99803f1-ce63-4132-aea3-66bb70342f97',
      /* 15.1 Bureaucracy and the Evolution of Public Administration to the same module in 2e */
      'eb93a6f4-edc3-4a02-a26c-59faeae71c4b': '07d930bd-80db-48b5-958f-f2280b9ebdf2',
      /* 15.2 Toward a Merit-Based Civil Service to the same module in 2e */
      '39c1b936-f0dd-4341-a1cb-6c9449f2715f': '75501032-f37d-442b-9672-ee923e861f00',
      /* 15.3 Understanding Bureaucracies and Their Types to the same module in 2e */
      '2979f445-bec9-4ae3-94f9-f9c772ce9e9f': '0931bb7a-0181-4267-b79c-0b3e04b14a3f',
      /* 15.4 Controlling the Bureaucracy to the same module in 2e */
      '08ada2c8-89d9-4641-b993-bed8515ea23e': 'f41badb3-ef10-44e8-b879-b952d737d7d2',
      /* 16.0 Introduction to the same module in 2e */
      '2622cf6c-5acf-4b0b-a3f1-9ac89f2ec025': 'f21be3c3-e961-4b58-81a6-9fdffa41b19b',
      /* 16.1 What is Public Policy? to the same module in 2e */
      'ebd1ac6d-f33e-487e-8906-8d9ad88b9ff1': '9f36abf1-8a4f-4cb5-8f19-e038d120a3e3',
      /* 16.2 Categorizing Public Policy to the same module in 2e */
      '49dc3f4c-22ba-448a-a334-654b7425d867': '1d8926ba-8aa0-4804-a4b2-0b962b7b8010',
      /* 16.3 Policy Arenas to the same module in 2e */
      '3b22b8ed-450a-4077-b25f-8ee425ad2439': 'cf773e85-df38-49c3-aec3-3cee17f1c70b',
      /* 16.4 Policymakers to the same module in 2e */
      '9f8d0c73-0533-4fe7-9aef-e978b61b27fc': 'd063d604-3d34-4775-8be6-cb7c77a6c314',
      /* 16.5 Budgeting and Tax Policy to the same module in 2e */
      '10c74228-8722-4825-a50f-a9d35b4489d5': '3401a477-02c2-451c-a574-d837f26445fb',
      /* 17.0 Introduction to the same module in 2e */
      '627c0478-669d-4d41-9039-76b854a640a0': '6d0bcc16-3c09-43fe-9a69-7dca0bdf5966',
      /* 17.1 Defining Foreign Policy to the same module in 2e */
      '497848cb-d4ad-4b0b-8295-c3dd1c9f7437': '8ca6f524-dbdb-4627-9a98-0ce15179829d',
      /* 17.2 Foreign Policy Instruments to the same module in 2e */
      '76c60115-aa26-4596-b673-a6e12a16c613': 'a537b76d-6188-49ab-a2cf-87bae04094a3',
      /* 17.3 Institutional Relations in Foreign Policy to the same module in 2e */
      '515d833c-0ba2-41ab-96b9-9fbeed85817c': 'b76ea2cb-fbac-4ff1-8d41-2dffc1e3d98e',
      /* 17.4 Approaches to Foreign Policy to the same module in 2e */
      'b36f239d-9025-47bf-957e-bbb675d4cd92': '8c2f6286-6f4c-4448-830e-c585282ea466',
      /* Declaration of Independence to the same module in 2e */
      '634b2a40-8f9d-4eca-b8b4-9f8df33f556b': '97a153dd-5719-4de8-b8e7-828b7f5b4396',
      /* The Constitution of the United States to the same module in 2e */
      'e752e52a-f95b-4e60-8c26-d6d93503b060': '1ec16a27-0461-4812-b91b-ffa28f8d8232',
      /* Federalist Papers #10 and #51 to the same module in 2e */
      'c187510d-48b5-4038-b002-f570afe989ad': '4a682489-9204-46b4-89c0-261ae689d86b',
      /* Electoral College Votes by State, 2012–2020 to the same module in 2e */
      '442e78a0-684d-45e2-a789-11bc53d25582': '985b4a50-7460-400f-a21d-92944c265ecb',
      /* Selected Supreme Court Cases to the same module in 2e */
      '02464308-7851-45b3-ba62-1d2b90c38ecd': '04a407a3-7158-4b76-aae1-950913b78341',
    }],
  ],
   /* American Government 2e */ '9d8df601-4f12-4ac1-8224-b450bf739e5f': [
    /* American Government 3e */['30e47181-f52c-4a91-9c11-33380c428268', {
      /* Preface */
      'c4926429-a48a-4355-8292-dea184b74340': '3ddde3e1-0765-4692-a525-58f481af278b',
      /* 1.0 Introduction */
      '4a3754eb-83a0-4a71-aa2c-aa8dfcd00086': '47f8f28a-cfb1-4323-8f23-c7bd71856e99',
      /* 1.1 What is Government? */
      'eb050d47-697c-412f-a5d0-0e30be4efd91': '1105deb5-ddeb-4777-80cf-f844a0d1492b',
      /* 1.2 Who Governs? Elitism, Pluralism, and Tradeoffs */
      '93d9cc58-fda5-4e87-8440-4d955adac103': '1df654ee-6899-49a8-a1a2-8a6f85610fa3',
      /* 1.3 Engagement in a Democracy */
      '5eab7fe7-562f-4e15-b77c-3ff42fa77040': '3cde8682-1626-42e6-902d-d6f01e4cc538',
      /* Ch. 1 Key Terms */
      'dd8eaea8-c24d-5499-8fca-2a6985125a69': 'd5834afe-6a24-5418-87ff-8334d5b869e5',
      /* Ch.1 Summary */
      '0134e78e-1718-5e31-ab71-40ae8c85528d': '46368a5c-c453-5067-a6a7-bf1bb0f6efe3',
      /* Ch 1. Review Questions */
      '095cc16e-cdc5-5ca5-80ef-c3a97feb9ce3': 'b2904919-a2c9-5ef4-9e0a-4af930761b20',
      /* Ch1. Critical Thinking Questions */
      '3808e842-21f1-5551-ae4d-617e7c9efacf': '6b838867-f91b-583b-b34c-6eeff18b4027',
      /* Ch1. Suggestions for Further Study */
      '91f4513e-e094-5330-b8a8-bd3fcc8a1511': '2420eb1f-7f3f-55ec-a2f1-f7e90a76a002',
      /* 2.0 Introduction */
      '67151eaa-f25c-4e63-ba20-9ab902031081': '0acb62c3-5ee2-4202-a325-96983c7015d9',
      /* 2.1 The Pre-Revolutionary Period and the Roots of the American Political Tradition */
      'd7f8e6e8-48fb-48d2-9998-e946750e7996': '26e5cf13-84b1-40ad-8538-8fbd73ab94cf',
      /* 2.2 The Articles of Confederation */
      '18083da1-5f89-4378-ba19-aa95e6996459': 'b1c8c9e2-5571-4d8e-85db-0a3d6d9cb17b',
      /* 2.3 The Development of the Constitution */
      '3dfca04b-06c7-4279-9602-6360152f1f37': 'b4b48c79-2ad8-45fe-9993-e37900e03d8a',
      /* 2.4 The Ratification of the Constitution */
      '3416922d-f5b2-431d-8793-89ed4b191fbb': '5dfb7c7b-c9c2-4911-8769-873adc2d054d',
      /* 2.5 Constitutional Change */
      '8d723639-0e23-4a8d-9446-735b192d64df': '40f8c706-891b-4236-891d-13159e643868',
      /* 3.0 Introduction */
      'eeedc8ee-9b04-4378-b4b7-2fc309d4353b': 'f7de2032-db57-44ed-9b6c-2453aa420cc9',
      /* Ch. 2 Key Terms */
      'f5e0db9c-1f7e-5a5a-bbf5-8105e14cd345': 'd78cc553-cfd5-503c-a6ab-bd2c1c9f20ac',
      /* Ch. 2 Summary */
      'e2ea1034-a341-548a-9a94-bcec87288b2a': '30f5a09f-6130-5a40-bfe0-afdcd3b8f007',
      /* Ch 2. Review Questions */
      '0406f45f-4070-5209-9c53-ad9952ff4ae9': '794f17f2-1d91-5ea5-83cc-811efbb15cea',
      /* Ch2. Critical Thinking Questions */
      '3c14d9a2-8b7f-5353-8e8d-72a6fd6cd140': 'f78d1e70-3f6b-5417-af31-4aa03b2ace9a',
      /* Ch2. Suggestions for Further Study */
      'f64b219f-3666-5c8a-974d-b4568787962b': '870d5d83-87f4-5bbe-b0a7-5ef5aecc9b9c',
      /* 3.1 The Division of Powers */
      '26b2bfe5-efa5-483d-8f8a-8a323b2b6d6b': '24e2e5a3-0f2d-442b-ad45-87d7ebd4ad78',
      /* 3.2 The Evolution of American Federalism */
      '7b4c299e-19d2-46bb-af4d-d2d6ff10ff9a': '8343b65e-02ae-493f-b015-83b060b81649',
      /* 3.3 Intergovernmental Relationships */
      'a7813753-6adb-4c84-a5ac-3352bb2715ce': '0fc32f7c-a8e3-4739-9729-4297630e2646',
      /* 3.4 Competitive Federalism Today */
      '63a73c4a-103d-46ab-82fa-179f801ebe7a': 'b34fa025-904a-41ab-af57-a54866886dd4',
      /* 3.5 Advantages and Disadvantages of Federalism */
      '761288f3-35fa-428b-9c60-081a7f73c941': '015fceb6-72f3-413b-95d9-fddfbb2cbc41',
      /* Ch. 3 Key Terms */
      'f8806b8f-cebe-5de5-a147-b40effbc2113': 'd5ea2e91-3e52-5c33-b0ea-e6964f7821ca',
      /* Ch. 3 Summary */
      '0e53845d-73ac-530e-a82e-f1784542653d': 'b7a1d097-89fe-55ab-b3e9-02295638778e',
      /* Ch 3. Review Questions */
      'b9e6aa4f-6486-5a98-996a-f6a92c10b896': '1b0fe0da-f7fa-58eb-89e3-2f8926dbb6eb',
      /* Ch 3. Critical Thinking Questions */
      'fe848cb6-b951-5ec8-ac55-c74e3e557db0': '8eb0df07-7840-58a1-8a50-4f0e56dcf4d2',
      /* Ch 3. Suggestions for Further Study */
      '7c7c5b24-d99e-52bc-9bd1-ad805976d3cd': 'cae777d4-9f4b-52d0-b9b1-663224e4c6eb',
      /* 4.0 Introduction */
      '0d6e143b-69fd-422b-9954-6dbbf6b36008': '2db6b141-4e2e-43f0-b782-b241acf60b55',
      /* 4.1 What Are Civil Liberties? */
      '2aafcd29-e648-4b86-b8b7-84d0ce46f906': 'eb3e05c2-0768-4325-9ef2-80f400303115',
      /* 4.2 Securing Basic Freedoms */
      '36890cdb-3867-4c73-b665-f17eea38cc76': '57462d7e-2d4a-4866-85b8-00b9d09544d1',
      /* 4.3 The Rights of Suspects */
      '507dc96f-6ec6-4f43-8d5d-5697ed5864a8': '7760a2b3-c3b9-416c-9520-b8cc4fa954fa',
      /* 4.4 Interpreting the Bill of Rights */
      'cc6b4911-b2aa-4dcd-8129-5802a309cb7b': 'cb752abe-3cf9-4da4-8fc5-60b9e3752e5a',
      /* Ch. 4 Key Terms */
      'ad7bf25b-af23-5516-ba1f-5e7c81d261d9': 'f76b2ad8-e6ec-5177-94cc-5843e1df5dfa',
      /* Ch. 4 Summary */
      '62e84f28-2696-52e8-a5e2-3fbfff6963ae': 'dd8d70f6-3d46-5301-9fbe-7552b525c370',
      /* Ch 4. Review Questions */
      'b8304828-0ed2-5358-8e72-e928c237d964': 'dd8d70f6-3d46-5301-9fbe-7552b525c370',
      /* Ch 4. Critical Thinking Questions */
      '7ce01d45-8906-5129-ab14-598dd57e7851': '8eef7b5b-373c-5ee1-b83d-978a902a2b40',
      /* Ch 4. Suggestions for Further Study */
      'dc8082a7-1c37-5df4-bb3a-0c360d6f3d37': '4bcccdbc-b776-59dc-af42-b9a69af217fd',
      /* 5.0 Introduction */
      '9fab3e71-ddb5-4dd9-bfd4-c9bc9b98141e': '9d5dd1d4-a37c-45be-a6c5-1af41cabed33',
      /* 5.1 What Are Civil Rights and How Do We Identify Them? */
      '02c754ad-fb36-42df-ac81-e0bfe37ceeac': '2d27051a-78f8-4af2-acc1-d6ca2217ef70',
      /* 5.2 The African American Struggle for Equality */
      '4e81320d-2ca0-4605-99d7-3ad5eb7dde0c': '74a23661-4daf-4a10-bc9d-c3ed4f376559',
      /* 5.3 The Fight for Women’s Rights */
      '6057f571-0573-4c6f-8156-e3e643347572': '9e78d921-0fcf-442a-9559-fb776b07f83a',
      /* 5.4 Civil Rights for Indigenous Groups: Native Americans, Alaskans, and Hawaiians */
      'b12ed755-9c80-45c2-81d0-c00f1f017a2e': 'abd1148e-11a9-497a-a8b9-5fb54fa0fa65',
      /* 5.5 Equal Protection for Other Groups */
      '5530879b-b714-4797-a228-c86d4e2af8de': 'adbb9b19-c66e-4349-84ec-ac884a95350f',
      /* 6.0 Introduction */
      '57789f84-8f8e-4b72-b312-1783ec50e6c5': 'df668cb5-1468-413b-bb81-48892079c551',
      /* Ch. 5 Key Terms */
      '27b93b5d-5f9f-59c5-9ee0-cf8631d0361c': '5033fc98-453c-568f-b28d-8094599da62b',
      /* Ch. 5 Summary */
      '66eef679-7748-5b14-bd4e-98d1781a232c': '2cd69c8f-bc5b-5609-8d32-4b1570bb06b8',
      /* Ch 5. Review Questions */
      '5321c158-9239-5106-b4e3-09b0c8ebeb99': 'bdcb2466-3e34-5ab1-9a86-abbdfec8fd8b',
      /* Ch 5. Critical Thinking Questions */
      '7b5fbf64-ec92-5aa0-8bd8-6236a9c019ec': '7347cbf1-a528-5b68-be39-77d06fd0e3be',
      /* Ch 5. Suggestions for Further Study */
      'eb2b25dc-3874-52b7-8104-902bb8f07174': '21667ba9-2c4d-55c0-bc1b-bb22e69bc1f9',
      /* 6.1 The Nature of Public Opinion */
      'ef525da9-efd3-4dac-b08b-4cb9f5eecbd4': '27c601c8-bbe9-47e2-9d5d-530471dc0d6d',
      /* 6.2 How Is Public Opinion Measured? */
      '4e320e18-2516-4803-93ef-f4808b319a8d': '6a864811-c55a-4a9b-86f1-e54f7f267200',
      /* 6.3 What Does the Public Think? */
      '0e325675-c403-4183-ad3f-bb51c880def5': '6a4ab4fc-1153-4177-9f06-5674d9e2d35c',
      /* 6.4 The Effects of Public Opinion */
      '94c9826d-0899-4fdb-9ecc-382acb8501d5': '035914b9-6d85-44e2-aa6a-b5ea7a4a0de3',
      /* Ch. 6 Key Terms */
      'bdb74628-7db5-5056-89a8-0861faaba15d': '8c44ab03-53f8-5d9a-8efd-3dc88ddec056',
      /* Ch. 6 Summary */
      '1a9d24d1-3be6-5ffc-93d8-a828a214891': '22e4a3bd-a564-54e1-be93-0ee8ef964e11',
      /* Ch 6. Review Questions */
      '89f851c6-27a0-5405-a6c0-f96a6e79311d': 'd2d68eec-20a6-574d-b5b8-597deda4c6dd',
      /* Ch 6. Critical Thinking Questions */
      '828fdc65-9f39-56ea-a951-9bd6d46e995b': 'b87bd66c-1b0d-5057-b0d1-a9936f8a5f88',
      /* Ch 6. Suggestions for Further Study */
      '6113d680-4860-5dcd-b509-a5a9cd194b4b': 'c532f364-76ab-5d4d-b487-47657d56b8e6',
      /* 7.0 Introduction */
      '81163025-bf42-4059-8160-cacca24446dc': 'cc0700a4-b5dd-4f20-be5d-ab2197d6aba9',
      /* 7.1 Voter Registration */
      '3edaca44-5ab0-4a42-a6b8-4247f6faa221': '6ef5c455-9913-48dd-b5dc-baa1c504d705',
      /* 7.2 Voter Turnout */
      'acbc4c4b-a232-4d19-95b0-9a24b8e42800': '82c33a61-85a8-4d52-9da1-22557766fe8a',
      /* 7.3 Elections */
      '86fe2723-48b6-4e8d-a7af-9dc27ad0d37e': 'af5199d5-f904-4823-93a1-e6d7d07b3e31',
      /* 7.4 Campaigns and Voting */
      'bda29a31-1f25-4371-8376-785c6a0ddf9a': 'f5119285-0710-42ac-b138-8c0d29f475fd',
      /* 7.5 Direct Democracy */
      '7f85b54d-4062-4945-bfa9-2ebca3dd2a61': '0ecf3286-577c-4e30-b3c8-fb404d662bfa',
      /* Ch. 7 Key Terms */
      '013ec43a-a29e-5f1a-8cf4-fd8db6df3808': '19c7bc6d-8ac0-554c-aa93-52f4a7eab053',
      /* Ch. 7 Summary */
      '4b968a0b-705f-5df6-ace7-42e2a78b620e': 'e9432dca-cbe0-53da-a979-8a3bdf427a56',
      /* Ch  7 Review Questions */
      '519a698c-e55d-5358-8c8a-0f47d69ac743': '8a7198d3-6acb-5f8f-8cba-ed1c6142095f',
      /* Ch 7. Critical Thinking Questions */
      '4149a30-9736-566d-b1cd-8fb52141452e': '3aae4505-6eb5-58cf-8fd8-f0b302fa7c01',
      /* Ch 7. Suggestions for Further Study */
      '774d278d-aeb8-5b75-bd1d-de1c366299bf': '26c4cf47-ea41-5279-8d4b-d2d90c768d83',
      /* 8.0 Introduction */
      '9a5cabad-893a-48f7-bce0-339ea4a6e9c0': '4ae046d7-323a-4461-b376-80fb519a2b9f',
      /* 8.1 What Is the Media? */
      'fa293618-ec42-4460-9581-193ab4423fc6': 'd99257c0-99a0-4fbd-a37d-24dc4f8b4bf6',
      /* 8.2 The Evolution of the Media */
      '8c5fc05a-8a77-4fe5-aabc-fa17072249d5': '7ddcab89-17f6-44a1-b776-fbcd5496cfa0',
      /* 8.3 Regulating the Media */
      '8592700f-ca63-47f5-833c-cbda1ac79802': 'ddaabc97-5173-416c-a395-93de3b97cc29',
      /* 8.4 The Impact of the Media */
      '7631529b-09c7-4d79-84f3-d30b9c8b06c9': '79abc4c0-9d0d-46fd-8f4b-d9e5342e4521',
      /* Ch. 8 Key Terms */
      'b4efd96b-f216-527a-b811-2e7b91cbe643': 'd67a34c4-f2c3-51c1-b497-8ee50b685a49',
      /* Ch. 8 Summary */
      '1f9bea4a-07b8-5f06-923d-cece1a147374': 'b9ea40bd-2bab-5f76-9521-514d3ea8f7f5',
      /* Ch  8 Review Questions */
      '192382e1-c31b-5b6d-ab85-018178a0c72c': 'a2c15506-7cda-5af6-83a2-290463c896a9',
      /* Ch 8 Critical Thinking Questions */
      'c389d200-3058-594a-9377-328449673806': 'f5336bb5-424f-5d2c-be92-5da2d76e3072',
      /* Ch 8 Suggestions for Further Study */
      'df29ca73-8107-54b3-8719-611ffbea107a': '439e4818-aa09-52e0-85af-895d99e5ecae',
      /* 9.0 Introduction */
      'e2607669-d582-4ec0-9c58-5e5dcfaaf6a2': 'a249315d-6f4b-42c2-9b47-b95452c61a91',
      /* 9.1 What Are Parties and How Did They Form? */
      '9824235e-9e98-4cf1-af98-f569754dc520': '1256514d-6e71-40f1-9990-991749dfda9e',
      /* 9.2 The Two-Party System */
      'a5c1983c-ba62-47b1-877f-a24d8201d5a8': 'bd6b97dc-a859-434d-be99-e8739b6bb0dd',
      /* 9.3 The Shape of Modern Political Parties */
      'bde8d9cd-07c6-4965-8ae7-810f4c6a527d': '64a9b2ad-babb-4834-abd9-a69b6bb7a6fe',
      /* 9.4 Divided Government and Partisan Polarization */
      '0b8595d2-3991-4bd6-ad84-e0f6ad86e219': '767541a3-4cf0-4b69-9afe-70eb5e5f9b1f',
      /* Ch. 9 Key Terms */
      '4080c8bf-1e89-5927-b1e7-6f5e4bca4f98': '537e2445-1eca-5ef7-a76b-1d8c0a70aab1',
      /* Ch. 9 Summary */
      '64028003-abb8-574d-ac7a-9679e81e37dd': 'd9822122-0ab8-5095-8dc0-456a0a784e1b',
      /* Ch  9 Review Questions */
      '01e98221-287e-5e9a-8437-a8211636c509': 'c0ebec65-9b04-5e8b-8fc6-6e1f9eb5b333',
      /* Ch 9 Critical Thinking Questions */
      'd1ef0193-aa8a-5c2a-83e1-32c79abc1130': 'defa62bc-26a6-50ac-b90e-a44690c2e2af',
      /* Ch 9 Suggestions for Further Study */
      '713447c6-7a8c-582a-9084-02e35d6bc690': 'c6eafd35-a74d-5ed0-8103-5dbc16d80027',
      /* 10.0 Introduction */
      '023c8dc9-73ff-415e-a425-740122f650e4': '10b9f291-6c21-4b2a-bfa5-d9f956a7b115',
      /* 10.1 Interest Groups Defined */
      'b7e4fad8-6af8-4a63-a83c-0985ba6ff07b': '08ab7418-4b34-4a12-afa6-fd914a715079',
      /* 10.2 Collective Action and Interest Group Formation */
      'f71475e4-c8d2-4a4e-8fca-cf854bb8f31b': '8320d218-36c4-4389-8f51-f0e59e2eeeee',
      /* 10.3 Interest Groups as Political Participation */
      '621c1d37-0bc1-4190-a1b2-a9331f890b1a': 'f9500c23-31fc-40e8-94c5-334884b54d46',
      /* 10.4 Pathways of Interest Group Influence */
      'b53451a4-ff00-4e37-bd4c-86416ef08025': '37864b89-ebe7-470b-82d3-35944aa44819',
      /* 10.5 Free Speech and the Regulation of Interest Groups */
      'b23c70f4-00d9-49b8-a7d2-60ec2be8eb62': '7b71fbfd-9476-4f54-928f-8156f7a6a893',
      /* Ch. 10 Key Terms */
      'e06b7747-0085-5753-baf9-d1a8de65546f': '41603e72-6c14-59f0-afe0-072cef074cf7',
      /* Ch. 10 Summary */
      '402db5e3-38a5-5bf7-adbe-916dc5a16cab': '2e48e0c5-a006-5ecd-a58c-501d988967ba',
      /* Ch  10 Review Questions */
      'd134527c-872b-5912-b6e4-d94eb071eaf0': 'ba586c45-cd00-5324-95df-0d42e1b5936d',
      /* Ch 10 Critical Thinking Questions */
      'b320c046-ef42-5805-b498-7f99fbbe8061': 'afccc1de-d30b-55c3-9f4f-f8028b7ab5d6',
      /* Ch 10 Suggestions for Further Study */
      '914f6155-2aa8-548a-8272-a00ea5cebfdf': '7f85fa36-8ac4-5acc-9112-64ce04350fb3',
      /* 11.0 Introduction */
      'b4d25da7-c2d6-4f0d-a4b5-b7ce3094435a': 'fe018d16-2067-40ba-835d-89e0b9f7e039',
      /* 11.1 The Institutional Design of Congress */
      '4931b8c8-2ea9-4c3e-9d7f-f964f91bd3c6': '6199efb8-f2eb-490f-9ac2-27c644fa9387',
      /* 11.2 Congressional Elections */
      '555946f7-b655-4976-b2a7-4c0e6c246330': '6e9ad9d6-4fd5-4950-b9a0-fe847f9a75fe',
      /* 11.3 Congressional Representation */
      'f5cc1e30-9ec6-43f0-9881-c3c55df30b22': 'c1bd3f27-d95e-4322-8753-a023ea892917',
      /* 11.4 House and Senate Organizations */
      '9a0223cf-99e1-4db3-a7b4-16f00279d884': '710f9908-e826-4b95-9195-2fe844cf3191',
      /* 11.5 The Legislative Process */
      'd36b1525-9a8e-4ab0-a3df-84d1fee4695c': '343f9e7b-2486-4aba-b746-8984c04ae82a',
      /* Ch. 11 Key Terms */
      'a9ea2057-7281-51cf-8fa4-f3391b505e73': '07d9066e-3021-5c3c-be96-70a4aa9c15cd',
      /* Ch. 11 Summary */
      '8f1d9d73-4b02-5248-ad60-89c222ad1f85': '8f484736-aa4c-5e76-9dc9-c45562028ec3',
      /* Ch  11 Review Questions */
      '471a2484-27eb-57eb-9ef4-96371e531e36': '341c82b9-2144-54fb-88d9-33236d508c3e',
      /* Ch 11 Critical Thinking Questions */
      'f890c7d6-cc70-5cae-bc80-cbe878f6a600': '8b404d2d-dd55-5e99-827a-9cb44acc0acc',
      /* Ch 11 Suggestions for Further Study */
      '2e32a23c-2474-5642-b67c-e4578cf989bd': '86be35d5-d255-5226-a63d-1f2414d78a7c',
      /* 12.0 Introduction */
      '2f367330-79fe-4ab4-940c-eece1443c465': '310044aa-f728-4875-99f8-54fd5f771aba',
      /* 12.1 The Design and Evolution of the Presidency */
      '5abe0bea-2667-4c18-bcda-634d14955c44': '932d9a9e-e892-48fb-9541-5116d6a805e1',
      /* 12.2 The Presidential Election Process */
      '3aa74b81-86b7-4b32-a1a5-897f30b6cac1': 'f27a2d49-5377-4915-a1e4-fbc470346010',
      /* 12.3 Organizing to Govern */
      'cfeafd49-fd97-4971-8fb7-c1ffe5cbfdcb': '481612e6-f7e2-4fee-9ec2-90a811bbab1c',
      /* 12.4 The Public Presidency */
      '27b0fa06-f702-47f9-bc56-776ff4cd74ec': 'e3571a7b-3d87-4ac5-9642-981141b86dbe',
      /* 12.5 Presidential Governance: Direct Presidential Action */
      '41d82607-554c-4d2c-a0e5-479488e8e79e': 'de1695dc-a8e6-474a-a703-9d8b00c1ee1d',
      /* Ch. 12 Key Terms */
      'f7a39d78-8e49-5323-9a5e-ce644128ae8c': '873e57d4-5b70-54c4-acbc-95f4b6ff0273',
      /* Ch. 12 Summary */
      '73fa1f35-c3fb-574e-b4ef-5c651b14bbca': '9545b3b4-bf87-551f-9ef0-28b5ecd6db71',
      /* Ch  12 Review Questions */
      'fcf75eaf-b380-567f-b67f-b7e0bc7d47dd': '0e627595-9688-593d-9acc-ee219b42eab1',
      /* Ch 12 Critical Thinking Questions */
      '572a6cc5-568b-5ec0-bf25-95d280c1c926': 'ac9556b9-3717-5d47-9db2-050bdf98c674',
      /* Ch 12 Suggestions for Further Study */
      'c3c76abb-1481-5611-8c63-2e3660a68f2a': '9d4348b6-0f84-5461-9ff9-65036ef2b018',
      /* 13.0 Introduction */
      '3f2ac0cb-b3af-4401-9a6a-49b684141f08': 'fa7f59b0-7449-4259-ac58-c03a48e91a63',
      /* 13.1 Guardians of the Constitution and Individual Rights */
      '0c441e8b-99de-4706-915c-615af32b2aa0': 'fa0a555c-ebd6-4c95-a6e9-b13f56b991dc',
      /* 13.2 The Dual Court System */
      '42aa74ae-0a1e-4ebc-a4f5-38507a7b4dc8': 'a44deb15-adb0-4b53-8639-655481d0a424',
      /* 13.3 The Federal Court System */
      '04b01d06-073e-4458-aaf5-d4e573ef34cf': '3f70a13f-b0ee-4352-85ca-133d1163e1f0',
      /* 13.4 The Supreme Court */
      'a1c80484-edb4-49ab-98a2-329cf2d2f9b3': '94177f18-ac67-4cfc-b2e7-77c694457ba4',
      /* 13.5 Judicial Decision-Making and Implementation by the Supreme Court */
      'f11ccf83-1b1e-4c33-9f37-4ad3e09509e1': '4a2a2bda-0f5d-454c-8a23-04df0002e0d1',
      /* Ch. 13 Key Terms */
      'e2394eb2-6492-5de4-ac29-fcd2a9f83557': '64ec1313-0184-505e-af28-fcb7a1ed9854',
      /* Ch. 13 Summary */
      '5d5b0013-05ad-5968-bcf2-6b0945653c66': '17a1ca81-90fa-5495-96f8-4841464f6608',
      /* Ch  13 Review Questions */
      'bddfe6ea-e6a5-58cf-9285-1254300fba28': 'edb0134a-4ce0-51bc-baa2-6e8f5b00a2ec',
      /* Ch 13 Critical Thinking Questions */
      'c4d1513f-86a8-5fdf-b1a2-8237ed93c8ec': '5eea0fbf-c16f-5048-ac64-51f9fa08d4a3',
      /* Ch 13 Suggestions for Further Study */
      '59c01ad3-18b6-51be-a064-aa2b132e73d9': 'f89654dd-b04b-5d79-b978-4ed66f463791',
      /* 14.0 Introduction */
      '2387f759-b473-4eca-addf-ce4647da62a9': '12759463-1dc1-49e7-96a6-280154ef0a0c',
      /* 14.1 State Power and Delegation */
      '026142b1-c0a3-4ad4-b803-f71ff664c8b5': '246672e7-c242-430d-a7bf-92d222774ada',
      /* 14.2 State Political Culture */
      'd76b7e9e-cf6a-498f-b9e2-32a57b967577': '8e532a78-4479-4484-906b-f7c0997cb627',
      /* 14.3 Governors and State Legislatures */
      '96054a57-adb9-4a2e-8d36-061868c9908d': '7a179ea7-cc0d-4e63-b289-dbc5734ed409',
      /* 14.4 State Legislative Term Limits */
      '5fdbd6f9-bcea-4b86-a0ac-436d779ddd89': '2f232356-cbee-4fbb-84a7-f09087818965',
      /* 14.5 County and City Government */
      '851a64e1-b529-4707-951f-b033813b146c': 'ad7cceb0-fb00-4395-b54b-9cab17583a8a',
      /* Ch. 14 Key Terms */
      '9cbb47e8-5859-5427-92e8-f02fb9054c6a': '9e83cb44-8ec0-57dd-ae8c-3a5c92de9563',
      /* Ch. 14 Summary */
      '6e614502-d097-5c47-86c4-10bcdc6deacc': 'f8d66e75-1b90-567d-80be-7a31c1ad1d4c',
      /* Ch  14 Review Questions */
      '66131ef6-ae6a-513c-adfa-a4584cf29705': '592457ec-ba50-568e-9a41-ebf03bb4bcc1',
      /* Ch 14 Critical Thinking Questions */
      '6759b865-199b-52ae-8758-c7307dafef62': '611d80bf-8509-5672-b9ee-87dfe8dc1884',
      /* Ch 14 Suggestions for Further Study */
      'b37eae28-169d-5a3f-9014-b36d14a7ef5c': '1414a079-cf41-5fd5-b6c6-4803a22533b0',
      /* 15.0 Introduction */
      '3486b86f-ed32-425d-92c9-deb2962e555d': 'd99803f1-ce63-4132-aea3-66bb70342f97',
      /* 15.1 Bureaucracy and the Evolution of Public Administration */
      'eb93a6f4-edc3-4a02-a26c-59faeae71c4b': '07d930bd-80db-48b5-958f-f2280b9ebdf2',
      /* 15.2 Toward a Merit-Based Civil Service */
      '4a55c966-14ef-4d07-9357-56c59da52da9': '75501032-f37d-442b-9672-ee923e861f00',
      /* 15.3 Understanding Bureaucracies and Their Types */
      '7596b909-3ca4-4548-8297-168fafe26d94': '0931bb7a-0181-4267-b79c-0b3e04b14a3f',
      /* 15.4 Controlling the Bureaucracy */
      '82dba630-0269-4be8-b12a-337cd88c3582': 'f41badb3-ef10-44e8-b879-b952d737d7d2',
      /* Ch. 15 Key Terms */
      '2f86faa0-ed20-5a4d-a5bf-81eb792521a6': '77fde099-4fa4-56d0-9f87-cac859eff061',
      /* Ch. 15 Summary */
      '137de0da-5167-5f4b-b185-dc636a571d75': '8f816dc6-25d8-5faf-a6f4-f65d82715397',
      /* Ch  15 Review Questions */
      'de0947b7-aed1-5cce-a2cb-442f0e2265ef': '0e0262d3-905a-5c61-b75c-dfe3bc70d4e2',
      /* Ch 15 Critical Thinking Questions */
      '8fa71175-b10f-5456-bac5-1228c3eb3383': 'd1ab5fc7-893e-5e59-97c1-abbab3ba2a94',
      /* Ch 15 Suggestions for Further Study */
      '52d3bf53-06fb-546a-b964-c2474b96cbf8': 'd930daef-385c-5d1e-b7c3-99457df41381',
      /* 16.0 Introduction */
      '2622cf6c-5acf-4b0b-a3f1-9ac89f2ec025': 'f21be3c3-e961-4b58-81a6-9fdffa41b19b',
      /* 16.1 What is Public Policy? */
      'e4fa32ea-a7df-4fbe-9447-27fd27a100ff': '9f36abf1-8a4f-4cb5-8f19-e038d120a3e3',
      /* 16.2 Categorizing Public Policy */
      '49dc3f4c-22ba-448a-a334-654b7425d867': '1d8926ba-8aa0-4804-a4b2-0b962b7b8010',
      /* 16.3 Policy Arenas */
      '3b22b8ed-450a-4077-b25f-8ee425ad2439': 'cf773e85-df38-49c3-aec3-3cee17f1c70b',
      /* 16.4 Policymakers */
      '9f8d0c73-0533-4fe7-9aef-e978b61b27fc': 'd063d604-3d34-4775-8be6-cb7c77a6c314',
      /* 16.5 Budgeting and Tax Policy */
      'f8e28647-8280-4042-a880-2403cc6f81ba': '3401a477-02c2-451c-a574-d837f26445fb',
      /* Ch. 16 Key Terms */
      '151d79f3-940c-51a6-930f-fbabeab95438': '722bbabd-f67f-5401-a1c9-6a6c9ce00e06',
      /* Ch. 16 Summary */
      '5ccc9b4e-3b8a-57aa-9652-df59ac6c77d9': 'c76139b4-c816-53ce-ba28-c657b89c567f',
      /* Ch  16 Review Questions */
      '84132a39-e351-526c-8a36-30b839459cbc': '35c12d71-930e-5427-b68b-5587961effca',
      /* Ch 16 Critical Thinking Questions */
      'e8a6d430-2c34-5bc9-99ff-ea66eb4fafa2': '907d3762-11d6-5790-affb-539a19e86303',
      /* Ch 16 Suggestions for Further Study */
      '0ca0f94b-1db8-5535-bb0b-84c9337bff85': 'b9cc1390-e45d-5d5e-ae77-512428d30b5e',
      /* 17.0 Introduction */
      '2c65013c-cadc-4026-91a8-85d45bafa54f': '6d0bcc16-3c09-43fe-9a69-7dca0bdf5966',
      /* 17.1 Defining Foreign Policy */
      '97427ce7-6595-4724-ae7a-70ad5762acf2': '8ca6f524-dbdb-4627-9a98-0ce15179829d',
      /* 17.2 Foreign Policy Instruments */
      '8ef511be-c234-46f5-9d51-af477dfa8b5e': 'a537b76d-6188-49ab-a2cf-87bae04094a3',
      /* 17.3 Institutional Relations in Foreign Policy */
      'cbafa76d-f210-4932-9bc7-7375be15b041': 'b76ea2cb-fbac-4ff1-8d41-2dffc1e3d98e',
      /* 17.4 Approaches to Foreign Policy */
      'b51bcbb9-a922-4f9c-89a4-65be1813e4c3': '8c2f6286-6f4c-4448-830e-c585282ea466',
      /* Ch. 17 Key Terms */
      '1b03fecd-a2b9-54a7-b00d-2da906d0c6ea': 'bced90cf-a419-5f92-83d6-6c601a631d71',
      /* Ch. 17 Summary */
      'e7b89e53-aaf9-53a9-9b8c-56a75bc898cf': 'a8584c3c-fa9e-58f3-ae9a-ea45d0c43c76',
      /* Ch  17 Review Questions */
      '1b967919-82c8-56d9-b21b-5a0614a3d5aa': 'da94339c-430b-525b-a336-1903d6ea7197',
      /* Ch 17 Critical Thinking Questions */
      '6638c3ec-3395-58f4-a3b9-f4d664da5146': '81b7f4b2-43fb-5f0b-9e84-0c032ad17f23',
      /* Ch 17 Suggestions for Further Study */
      'c614a618-d271-5b9b-9a02-f4b4695a9d27': '7bd2d16a-2dc8-5b2d-9669-a42230e06088',
      /* Declaration of Independence */
      '634b2a40-8f9d-4eca-b8b4-9f8df33f556b': '97a153dd-5719-4de8-b8e7-828b7f5b4396',
      /* The Constitution of the United States */
      'e752e52a-f95b-4e60-8c26-d6d93503b060': '1ec16a27-0461-4812-b91b-ffa28f8d8232',
      /* Federalist Papers #10 and #51 */
      'c187510d-48b5-4038-b002-f570afe989ad': '4a682489-9204-46b4-89c0-261ae689d86b',
      /* Electoral College Map */
      '442e78a0-684d-45e2-a789-11bc53d25582': '985b4a50-7460-400f-a21d-92944c265ecb',
      /* Selected Supreme Court Cases */
      '3dcdfc26-ff45-4527-a53e-5b2000283627': '04a407a3-7158-4b76-aae1-950913b78341',
      /* Answer Key Ch 1 */
      'a75109c2-cd65-5d50-8753-40f1e8ab0794': '39955048-6862-5796-abe4-3e520332c91d',
      /* Answer Key Ch 2 */
      '8f816b6f-3ab2-581b-8f2e-8d13f65a417a': 'fa5f8a13-417b-5758-9ce1-4ef18cb5ea61',
      /* Answer Key Ch 3 */
      '744403dd-ef89-5304-a310-427f518d3732': '7cf19cfa-5941-5820-87b8-dd5a6440cbb1',
      /* Answer Key Ch 4 */
      '58e51a1a-e1b3-5b86-994f-0c076ec385f3': '8a1e5e0b-1531-5df0-bcbd-726a2a225747',
      /* Answer Key Ch 5 */
      '6cba5e54-75e1-5ffa-b127-38a4c029720a': 'bf21e90e-d2ec-513f-9dd2-4309e718c6c8',
      /* Answer Key Ch 6 */
      'acb03d44-1402-5f85-aa77-d5f06ee5c6b7': '92173589-fa52-59a0-ae36-7163d49af1dc',
      /* Answer Key Ch 7 */
      '6652b25c-9533-5e9e-b7a5-d836ed165a10': 'd88e5b81-20a9-5f83-a3e2-22121c676753',
      /* Answer Key Ch 8 */
      '913f1ac1-4877-559e-87f5-1ff32e2de5b7': 'b21362b4-7888-576e-af95-4a564657f949',
      /* Answer Key Ch 9 */
      '79666ff2-6d97-5a35-824a-a4610cb57042': '41b879db-b05a-527b-a622-b1cdb3bae152',
      /* Answer Key Ch 10 */
      '66241130-3d91-5aad-8036-0eb87ffe8987': '03fd63ae-c201-5f50-9e4b-58c903a616ab',
      /* Answer Key Ch 11 */
      'eb98c0c9-173f-54cb-bb35-9cffe4b9d1d5': '1da0ab01-c007-53d1-bb26-43659a3a3511',
      /* Answer Key Ch 12 */
      '65ff7b44-5259-5d9a-9ecb-8d29e8d9dccd': 'ea3edcda-0270-5743-bada-3cb3d1b846c1',
      /* Answer Key Ch 13 */
      'f52b82c0-8e20-5e29-a476-ce7b5db5f78b': 'ecddf519-280e-540c-ae83-f14422a1d06a',
      /* Answer Key Ch 14 */
      'f4d85378-a5b5-51a4-8709-a5c505d05cdb': 'faf46105-25f3-52c0-8e39-f4336caba63a',
      /* Answer Key Ch 15 */
      'ece2370f-9b64-5a14-9919-18e991d8a185': '21074d43-dad7-5506-b2be-a8ffdcb5b9d1',
      /* Answer Key Ch 16 */
      '4941fdc1-5b7e-515b-a67d-0f339deb1e6e': 'd7f32454-fed3-5771-b2fb-af5f055f8172',
      /* Answer Key Ch 17 */
      '340180e8-a1c0-5137-a81f-bb779800684c': 'bcb813cf-64c6-59e1-b1fd-4e11aefae589',
      /* Referrence */
      '631890c0-95db-5aca-a558-02a5e629a6ee': 'ccd70ac1-42fc-5e53-8a28-08336534f45d',
      /* Index */
      'c4679107-c958-5c8f-b65e-857f9b757536': '45f5e5a2-582c-50a0-8c2d-b9b8c93b5d45',
    }],
  ],
} as CanonicalBookMap;
